module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_feb_01-13392853bbe4153eb440bc3577ff2a73.png";